import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // Use useLayoutEffect for synchronous, immediate scroll reset BEFORE paint
  useLayoutEffect(() => {
    // Firefox-specific: Force scroll position before any rendering
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    // Aggressively reset scroll on every navigation
    const resetScroll = () => {
      // Reset window scroll - Firefox needs both
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      window.scrollTo(0, 0);

      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }

      // Firefox sometimes needs this
      if (document.scrollingElement) {
        document.scrollingElement.scrollTop = 0;
      }
    };

    // Execute immediately
    resetScroll();

    // Execute after microtask
    Promise.resolve().then(resetScroll);

    // Execute after next frame
    requestAnimationFrame(() => {
      resetScroll();

      // Reset scrollable containers after next frame
      requestAnimationFrame(() => {
        const scrollableElements = document.querySelectorAll('.page-text, .faq-content, .page-container');
        scrollableElements.forEach(element => {
          element.scrollTop = 0;
        });

        // One more reset after containers are cleared
        resetScroll();
      });
    });

    // More aggressive timeouts for Firefox
    const timeouts = [
      setTimeout(resetScroll, 0),
      setTimeout(resetScroll, 1),
      setTimeout(resetScroll, 10),
      setTimeout(resetScroll, 50),
      setTimeout(resetScroll, 100),
      setTimeout(resetScroll, 150),
      setTimeout(resetScroll, 250),
      setTimeout(resetScroll, 400)
    ];

    return () => timeouts.forEach(clearTimeout);
  }, [pathname]);

  return null;
}
